import { render, staticRenderFns } from "./CuzSwiper.vue?vue&type=template&id=6b0f682a"
import script from "./CuzSwiper.vue?vue&type=script&lang=js"
export * from "./CuzSwiper.vue?vue&type=script&lang=js"
import style0 from "./CuzSwiper.vue?vue&type=style&index=0&id=6b0f682a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports